"use strict";
/*
 * Created on 29. 11. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
}); //tslint:disable:variable-name

exports.BitSet = Object.assign(bitset, {
  of: bitsetOf,
  fromBinary: bitsetFromBinary
}); // Implementation
//tslint:disable:no-bitwise

function bitset() {
  var set = [];

  for (var _len = arguments.length, nums = new Array(_len), _key = 0; _key < _len; _key++) {
    nums[_key] = arguments[_key];
  }

  for (var _i = 0; _i < nums.length; _i++) {
    var it = nums[_i];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = it[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var n = _step.value;
        setAdd(set, n);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  return new BitSetImpl(set);
}

function bitsetOf() {
  for (var _len2 = arguments.length, nums = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    nums[_key2] = arguments[_key2];
  }

  return bitset(nums);
}

function bitsetFromBinary(nums) {
  if (nums.length > 100) {
    throw new Error('Set too big');
  }

  var set = cloneSet(nums);
  reduceSet(set);
  return new BitSetImpl(reduceSet(set));
}

function reduceSet(set) {
  var i = set.length;
  var n = i;

  while (i > 0 && (set[i - 1] & 0xffffffff) === 0) {
    i--;
  }

  set.splice(i, n - i);
  return set;
}

function cloneSet(set) {
  return set.slice();
}

function setAdd(set, bit) {
  if (bit > 5000) {
    throw new Error('Set too big');
  }

  var n = bit / 32;

  while (set.length < n + 1) {
    set[set.length] = 0;
  }

  set[n] = set[n] | 1 << n % 32;
}

function setRemove(set, bit) {
  var n = bit / 32;

  if (set.length < n + 1) {
    return;
  }

  set[n] = set[n] & ~(1 << n % 32);
}

var BitSetImpl =
/*#__PURE__*/
function () {
  function BitSetImpl(set) {
    _classCallCheck(this, BitSetImpl);

    this.set = set;
    /**/
  }

  _createClass(BitSetImpl, [{
    key: Symbol.iterator,
    value: function value() {
      var set = this.set;
      var ret = {
        pos: 0,
        bit: -1,
        next: function next() {
          while (this.pos < set.length) {
            this.bit++;

            while (this.bit < 32) {
              if ((set[this.pos] & 1 << this.bit) > 0) {
                return {
                  done: false,
                  value: this.pos * 32 + this.bit
                };
              }

              this.bit++;
            }

            this.bit = -1;
            this.pos++;
          }

          return {
            done: true,
            value: NaN
          };
        }
      };
      ret.next();
      return ret;
    }
  }, {
    key: "add",
    value: function add(n) {
      if (this.contains(n)) {
        return this;
      }

      var ret = cloneSet(this.set);
      setAdd(ret, n);
      return new BitSetImpl(ret);
    }
  }, {
    key: "remove",
    value: function remove(n) {
      if (!this.contains(n)) {
        return this;
      }

      var ret = cloneSet(this.set);
      setRemove(ret, n);
      reduceSet(ret);
      return new BitSetImpl(ret);
    }
  }, {
    key: "and",
    value: function and(other) {
      return exports.BitSet();
    }
  }, {
    key: "or",
    value: function or(other) {
      return exports.BitSet();
    }
  }, {
    key: "contains",
    value: function contains(n) {
      var i = n / 32;

      if (this.set.length < n + 1) {
        return false;
      }

      return (this.set[i] & 1 << n % 32) > 0;
    }
  }, {
    key: "intersects",
    value: function intersects(other) {
      if (!(other instanceof BitSetImpl)) {
        return false;
      }

      var a = this.set;
      var b = other.set;
      var m = Math.max(a.length, b.length);
      var i = 0;

      while (i < m) {
        if ((a[i] & b[i]) > 0) {
          return true;
        }

        i++;
      }

      return false;
    }
  }, {
    key: "containsAll",
    value: function containsAll(other) {
      if (!(other instanceof BitSetImpl)) {
        return false;
      }

      var a = this.set;
      var b = other.set;

      if (b.length > a.length) {
        return false;
      }

      var i = 0;
      var m = Math.max(a.length, b.length);

      while (i < m) {
        if ((a[i] | b[i]) !== a[i]) {
          return false;
        }

        i++;
      }

      return true;
    }
  }, {
    key: "size",
    get: function get() {
      var n = 0;

      for (var i = 0; i < this.set.length; i++) {
        n += bitCount32(this.size[i]);
      }

      return n;
    }
  }]);

  return BitSetImpl;
}(); //Copied from Java standard library


function bitCount32(i) {
  i = i - (i >>> 1 & 0x55555555);
  i = (i & 0x33333333) + (i >>> 2 & 0x33333333);
  i = i + (i >>> 4) & 0x0f0f0f0f;
  i = i + (i >>> 8);
  i = i + (i >>> 16);
  return i & 0x3f;
} //test


var bs = exports.BitSet();
bs.and(exports.BitSet.of(1, 2, 3, 4, 5));